import { request } from '@umijs/max';
import { getNebulithInferenceProApiUrl } from '@/services/util';

export interface GatewayEndpointResult {
  baseUrl: string;
}

/** 获取网关地址 */
export async function getGatewayEndpoint(
  options?: { skipErrorHandler?: boolean },
) {
  return request<GatewayEndpointResult>(
    getNebulithInferenceProApiUrl('gateway/endpoint'),
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}

export async function getGatewayBaseUrl(
  options?: { skipErrorHandler?: boolean },
): Promise<string | undefined> {
  try {
    const res = await getGatewayEndpoint(options);
    return res?.baseUrl?.trim() || undefined;
  } catch {
    return undefined;
  }
}
